export function parseResponse<T>(
  data: string,
  keys: string[],
  stringKeys: string[] = []
) {
  const isNumericValue = (value: string) => /^-?\d+(\.\d+)?$/.test(value);

  const interfaceKeys = keys as (keyof T)[];
  const forcedStringKeys = new Set(stringKeys);
  const values: (number | string | boolean | string[] | null | undefined)[] =
    data.split("|").map((value, index) => {
      const currentValue = value.replace(/"/g, "");
      const currentKey = keys[index];

      if (currentValue === "true") {
        return true;
      } else if (currentValue === "false") {
        return false;
      } else if (currentValue === "null") {
        return null;
      } else if (currentValue === "undefined") {
        return undefined;
      } else if (currentValue.startsWith("[") && currentValue.endsWith("]")) {
        const arrayValue = currentValue.slice(1, -1);
        return arrayValue.split(",");
      } else if (!forcedStringKeys.has(currentKey) && isNumericValue(currentValue)) {
        return Number(currentValue);
      } else {
        return currentValue;
      }
    });

  return interfaceKeys.reduce((obj, key, index) => {
    obj[key] = values[index] as T[keyof T];
    return obj;
  }, {} as T);
}
